/**
 * The synthwave render palette, in one place (single source of truth — see
 * AGENTS.md). Two deliberate families:
 *
 *  - RINK markings are scene lighting: cyan/magenta emissive lines on
 *    charcoal black-glass ice. Their tunable colors live in the style
 *    JSONs (ice/boards) next door; the constants here are the semantic
 *    anchors code branches on.
 *  - ENTITY colors are the team read: home blue vs away red-orange, chosen
 *    to separate instantly from both marking hues. Skater shells and goalie
 *    domes share the same family per team.
 *
 * The hero puck's gold lives here too. The offscreen arrow and the faceoff
 * bar share that gold family deliberately — both cues point at or lead to
 * the puck. Nothing else on the ice renders gold.
 */

export const RINK_COLORS = {
  ice: 0x0c1018,
  cyan: 0x2de2ff,
  magenta: 0xff2d95,
} as const;

export type EntityColorSet = { glow: number; core: number; rim: number };

export const TEAM_ENTITY_COLORS: Record<"home" | "away", EntityColorSet> = {
  home: { glow: 0x2470ff, core: 0x4db8ff, rim: 0xcfeeff },
  away: { glow: 0xff3914, core: 0xff7a3d, rim: 0xffe0c2 },
};

export const PUCK_GOLD = {
  core: 0xfff3c4,
  ring: 0xffb13d,
  streak: 0xffd84a,
} as const;
